import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { UspSlide } from "./usp-slide";
import styles from "./usp-container.module.css";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide, Wrapper } from "@cinch-nx/shared-ui";
import { useViewport } from "@cinch-labs/shared-util";
export function USPContainer({ slides =[]  }) {
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isTablet = vw >= 768 && vw < 1024;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: {
            container: styles.carouselWrapper,
            inner: styles.carouselInner
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.uspContainerDesktop,
                "data-testid": "USPContainerDesktop",
                children: slides.map((slide)=>/*#__PURE__*/ _createElement(UspSlide, {
                        ...slide,
                        key: slide._uid
                    }))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.uspContainerMobile,
                "data-testid": "USPContainerMobile",
                children: [
                    /*#__PURE__*/ _jsx(Carousel, {
                        name: "usp",
                        swiperSettings: {
                            slidesPerView: isTablet ? 2.1 : 1.1
                        },
                        children: slides.map((slide)=>/*#__PURE__*/ _jsx(CarouselSlide, {
                                children: /*#__PURE__*/ _jsx(UspSlide, {
                                    ...slide
                                })
                            }, slide._uid))
                    }),
                    /*#__PURE__*/ _jsxs(CarouselControls, {
                        customClassNames: styles.carouselControls,
                        children: [
                            /*#__PURE__*/ _jsx(CarouselNavigation, {
                                name: "usp",
                                ariaLabels: {
                                    next: "Next USP",
                                    previous: "Previous USP"
                                }
                            }),
                            /*#__PURE__*/ _jsx(CarouselPagination, {
                                name: "usp"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
